import { atom } from "recoil";

export const userToken = atom<string | undefined>({
  key: "userToken",
  default: undefined,
});

// export const getToken = selector({
//     key: 'getToken',
//     get: async ({ get }: { get: any }) => {
//         const { getMinPrice } = get(atomMinPriceFlag);
//         const authUser = get(atomAuthUser);
//         if (authUser.roles.includes('ROLE_EXECUTOR'))
//             return true;
//         return getMinPrice;
//     },
//     atom
// });
